import type { Service } from '~publish/contexts/AccountContext/graphqlEnums'

export const MAX_VALUE_LED_EMPTY_STATE_CHANNELS = 3

const DEFAULT_PREVIEW_SERVICES: Service[] = [
  'instagram',
  'facebook',
  'linkedin',
]

export function getValueLedPreviewServices(
  onboardingServices: Service[] | null,
): Service[] {
  const uniqueServices = [...new Set(onboardingServices ?? [])]
  const services =
    uniqueServices.length > 0 ? uniqueServices : DEFAULT_PREVIEW_SERVICES

  return services.slice(0, MAX_VALUE_LED_EMPTY_STATE_CHANNELS)
}
